var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getCountLinkParams } from "../getCountLinkParams";
export var getOutrightCountLinkParams = function (props) {
    return __assign({}, getCountLinkParams(props), { count: props.markets[0].selections.length });
};
//# sourceMappingURL=getOutrightCountLinkParams.js.map